import React, { useEffect, useState, useContext } from 'react';
import { Box } from '@mui/system';
import KenFormBuilder from './Components/KenFormBuilder';
import { UploadDocumentContextProvider } from '../../Context/uploadDocumentContext';
import {
  getApplicationByApplicationId,
  getContactInfoByContactId,
  getFormByFormId,
} from '../../Utils/apiServices';
import { useLocation, useNavigate } from 'react-router-dom';
import { FormContext } from '../../Context/formContext';
import KenLoader from '../KenLoader';
import { getNameById } from '../../Utils/Helpers/stringHelper';
import { useBack } from 'use-back';
import { REGEX } from '../../Constants/constant';
import { Country, State, City } from 'country-state-city';

const formJSON = [

  {
    stepId: 'basicDetails',
    stepName: 'Personal Information',
    showStepName: false,
    stepPosition: 1,
    stepVisible: true,
    stepType: 'form',
    showAccordionInMobile: true,
    sections: [
      {
        sectionName: 'Personal Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: "LastName",
            required: true,
            name: "LastName",
            label: "Full Name",
            type: "input",
            validationType: "alphaNumeric",
            validations: {
              required: "This field is required",
              maxLength: {
                value: 50,
                message: "Full Name cannot exceed 50 characters"
              },
              pattern: {
                value: REGEX.NAME,
                message: "Full Name should contain only alphabets and should not start or end with space"
              }
            }
          },

          {
            fieldId: `Birthdate`,
            required: true,
            name: `Birthdate`,
            label: 'Date of Birth',
            type: 'date',
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'Father_s_Name__c',
            required: true,
            name: 'Father_s_Name__c',
            label: 'Father Name',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 50,
                message: 'Maximum 50 characters allowed',
              },
              pattern: {
                value: REGEX.NAME,
                message: 'Father Name should contain only alphabets and should not start or end with space',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'Mother_s_Name__c',
            required: true,
            name: 'Mother_s_Name__c',
            label: 'Mother Name',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 50,
                message: 'Maximum 50 characters allowed',
              },
              pattern: {
                value: REGEX.NAME,
                message: 'Mother Name should contain only alphabets and should not start or end with space',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },

          {
            fieldId: `hed__Gender__c`,
            required: true,
            name: `hed__Gender__c`,
            label: 'Gender',
            type: 'radio',
            validations: {
              required: 'This field is required',
            },
            options: [
              { label: 'Male', value: 'Male' },
              { label: 'Female', value: 'Female' },
              { label: 'Other', value: 'Other' },
            ],
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: `Category__c`,
            name: `Category__c`,
            label: 'Category',
            type: 'select',
            options: [
              { label: 'General', value: 'General' },
              { label: 'OBC', value: 'OBC' },
              { label: 'SC', value: 'SC' },
              { label: 'ST', value: 'ST' },
            ],
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'hed__Religion__c',
            name: 'hed__Religion__c',
            required: true,
            label: 'Religion',
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[A-Za-z\s]+$/,
                message: 'Religion should only contain letters and spaces',
              },
              maxLength: {
                value: 30,
                message: 'Religion cannot exceed 30 characters',
              },
              required: 'Religion is required',

            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: "Phone",
            required: true,
            name: "Phone",
            label: "Mobile Number",
            type: "phone",
            apiKey: "Phone",
            validations: {
              required: "This field is required",
              pattern: {
                value: /^\+?91?[0-9]{10}$/,
                message: "Please enter a valid 10-digit Mobile Number"
              }
            }
          },
          {
            name: "Aadhar_Number__c",
            label: "Aadhaar Number",
            required: true,

            type: "input",
            validationType: "number",
            visible: true,
            fieldId: "Aadhar_Number__c",
            validations: {
              required: {
                value: true,
                message: "Field is required"
              },
              minLength: {
                value: 12,
                message: "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
              },
              maxLength: {
                value: 12,
                message: "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
              },
              pattern: {
                value: "",
                message: "Please input a correct value"
              }
            }
          },
          {
            name: "Pan_Number__c",
            label: "PAN Number",
            required: true,
            type: "input",
            validationType: "string",
            visible: true,
            fieldId: "Pan_Number__c",
            validations: {
              required: {
                value: true,
                message: "PAN number is required"
              },
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: "Invalid PAN number format. Example: ABCDE1234F"
              },
              minLength: {
                value: 10,
                message: "PAN number must be 10 characters long"
              },
              maxLength: {
                value: 10,
                message: "PAN number must be 10 characters long"
              }
            },
            // 👇 Force uppercase on typing
            onChange: (e) => {
              e.target.value = e.target.value.toUpperCase();
            }
          },

          {
            fieldId: 'Highest_Qualification__c',
            required: true,
            name: 'Highest_Qualification__c',
            label: 'Qualification',
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[A-Za-z0-9.\-\s]+$/,
                message: 'Please input a valid Qualification',
              },
              maxLength: {
                value: 100,
                message: 'Qualification cannot exceed 100 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: `Marital_Status__c`,

            name: `Marital_Status__c`,
            label: 'Marital Status',
            type: 'radio',
            validations: {
              required: 'This field is required',
            },
            options: [
              { label: 'Single', value: 'Single' },
              { label: 'Married', value: 'Married' },
              { label: 'Divorced', value: 'Divorced' },
              { label: 'Widow', value: 'Widow' },
            ],
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: `T_Shirt__c`,
            name: `T_Shirt__c`,
            label: 'T-Shirt Sizes',
            type: 'select',
            options: [
              { label: 'Small', value: 'Small' },
              { label: 'Medium', value: 'Medium' },
              { label: 'Large', value: 'Large' },

            ],
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            "fieldId": "Email",
            "required": true,
            "name": "Email",
            "label": "Email",
            "type": "input",
            "validationType": "email",
            "validations": {
              "required": "This field is required",
              "pattern": {
                value: REGEX.EMAIL,
                "message": "Please input a valid Email (e.g. lg@gmail.co)"
              }
            }
          },

          {
            "name": "hed__Address__c[0]",
            "type": "pincode",
            // "rule": {
            //   "effect": "SHOW",
            //   "condition": {
            //     "scope": "addresses[0][mailingCountry]",
            //     "expectedValue": "India",
            //     "type": "LEAF"
            //   }
            // },
            "options": [
              {
                fieldId: `Permanent_Address__c`,
                required: true,
                name: `Permanent_Address__c`,
                label: 'Permanent Address',
                type: 'input',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 12,
                    lg: 12,
                  },
                },
              },
              {
                fieldId: `Communication_Address__c`,
                required: true,
                name: `Communication_Address__c`,
                label: 'Communication Address',
                type: 'input',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 12,
                    lg: 12,
                  },
                },
              },
              {
                "fieldId": "Pin_Code__c",
                "name": "Pin_Code__c",
                "label": "PIN / PO BOX/ ZIP",
                "helperText": "If your city and state is not getting auto populated, Please use the nearest PIN / PO BOX/ ZIP",
                "required": true,
                "validationType": "number",
                "validations": {
                  "required": "This field is required",
                  "maxLength": {
                    "value": 6,
                    "message": "This field can't be more than 6 character"
                  },
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid Pin code"
                  }

                },
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              },
              {
                "fieldId": "State_for_LG__c",
                "name": "State_for_LG__c",
                "label": "State",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "type": "input",
                "ui": {
                  "gridType": "halfRow"
                }
              },
              {
                "fieldId": "City__c",
                "name": "City__c",
                "label": "City",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              }
            ]
          },

          {
            fieldId: `Bank_Name__c`,
            name: `Bank_Name__c`,
            label: 'Bank Name',
            type: 'select',
            options: [
              { label: 'AB Bank Ltd', value: 'AB Bank Ltd' },
              { label: 'India Post Payments Bank - IPPB', value: 'India Post Payments Bank - IPPB' },
              { label: 'Airtel Payments Bank Ltd', value: 'Airtel Payments Bank Ltd' },
              { label: 'American Express Banking Corporation', value: 'American Express Banking Corporation' },
              { label: 'Andhra Pradesh Grameena Vikas Bank', value: 'Andhra Pradesh Grameena Vikas Bank' },
              { label: 'Andhra Pragathi Grameena Bank', value: 'Andhra Pragathi Grameena Bank' },
              { label: 'Arunachal Pradesh Rural Bank', value: 'Arunachal Pradesh Rural Bank' },
              { label: 'Aryavart Bank', value: 'Aryavart Bank' },
              { label: 'Assam Gramin Vikash Bank', value: 'Assam Gramin Vikash Bank' },
              { label: 'Au Small Finance Bank Ltd', value: 'Au Small Finance Bank Ltd' },
              { label: 'Australia and New Zealand Banking Group Ltd', value: 'Australia and New Zealand Banking Group Ltd' },
              { label: 'Axis Bank Ltd', value: 'Axis Bank Ltd' },
              { label: 'Bandhan Bank Ltd', value: 'Bandhan Bank Ltd' },
              { label: 'Bangiya Gramin Vikash Bank', value: 'Bangiya Gramin Vikash Bank' },
              { label: 'Bank of America', value: 'Bank of America' },
              { label: 'Bank of Bahrain and Kuwait BSC', value: 'Bank of Bahrain and Kuwait BSC' },
              { label: 'Bank of Baroda', value: 'Bank of Baroda' },
              { label: 'Bank of Ceylon', value: 'Bank of Ceylon' },
              { label: 'Bharat Coperative Bank', value: 'Bharat Coperative Bank' },
              { label: 'Bank of China Limited', value: 'Bank of China Limited' },
              { label: 'Bank of India', value: 'Bank of India' },
              { label: 'Bank of Maharashtra', value: 'Bank of Maharashtra' },
              { label: 'Bank of Nova Scotia', value: 'Bank of Nova Scotia' },
              { label: 'Barclays Bank Plc', value: 'Barclays Bank Plc' },
              { label: 'Baroda Gujarat Gramin Bank', value: 'Baroda Gujarat Gramin Bank' },
              { label: 'Baroda Rajasthan Kshetriya Gramin Bank', value: 'Baroda Rajasthan Kshetriya Gramin Bank' },
              { label: 'Baroda UP Bank', value: 'Baroda UP Bank' },
              { label: 'BNP Paribas', value: 'BNP Paribas' },
              { label: 'Canara Bank', value: 'Canara Bank' },
              { label: 'Capital Small Finance Bank Ltd', value: 'Capital Small Finance Bank Ltd' },
              { label: 'Central Bank of India', value: 'Central Bank of India' },
              { label: 'Chaitanya Godavari GB', value: 'Chaitanya Godavari GB' },
              { label: 'Chhattisgarh Rajya Gramin Bank', value: 'Chhattisgarh Rajya Gramin Bank' },
              { label: 'Citibank NA', value: 'Citibank NA' },
              { label: 'City Union Bank Ltd', value: 'City Union Bank Ltd' },
              { label: 'Cooperatieve Rabobank UA/ Coöperatieve Centrale Raiffeisen-Boerenleenbank BA', value: 'Cooperatieve Rabobank UA/ Coöperatieve Centrale Raiffeisen-Boerenleenbank BA' },
              { label: 'Credit Agricole Corporate and Investment Bank', value: 'Credit Agricole Corporate and Investment Bank' },
              { label: 'CSB Bank Limited', value: 'CSB Bank Limited' },
              { label: 'CTBC Bank Co, Ltd', value: 'CTBC Bank Co, Ltd' },
              { label: 'Dakshin Bihar Gramin Bank', value: 'Dakshin Bihar Gramin Bank' },
              { label: 'DBS Bank India Limited', value: 'DBS Bank India Limited' },
              { label: 'DCB Bank Ltd', value: 'DCB Bank Ltd' },
              { label: 'Deutsche Bank AG', value: 'Deutsche Bank AG' },
              { label: 'Dhanlaxmi Bank Ltd', value: 'Dhanlaxmi Bank Ltd' },
              { label: 'Doha Bank QPSC', value: 'Doha Bank QPSC' },
              { label: 'Ellaquai Dehati Bank', value: 'Ellaquai Dehati Bank' },
              { label: 'Emirates NBD Bank PJSC', value: 'Emirates NBD Bank PJSC' },
              { label: 'Equitas Small Finance Bank Ltd', value: 'Equitas Small Finance Bank Ltd' },
              { label: 'ESAF Small Finance Bank Ltd', value: 'ESAF Small Finance Bank Ltd' },
              { label: 'Federal Bank Ltd', value: 'Federal Bank Ltd' },
              { label: 'FINO Payments Bank Ltd', value: 'FINO Payments Bank Ltd' },
              { label: 'First Abu Dhabi Bank PJSC', value: 'First Abu Dhabi Bank PJSC' },
              { label: 'FirstRand Bank Limited', value: 'FirstRand Bank Limited' },
              { label: 'HDFC Bank Ltd', value: 'HDFC Bank Ltd' },
              { label: 'Himachal Pradesh Gramin Bank', value: 'Himachal Pradesh Gramin Bank' },
              { label: 'Hong Kong and Shanghai Banking Corporation Limited', value: 'Hong Kong and Shanghai Banking Corporation Limited' },
              { label: 'ICICI Bank Ltd', value: 'ICICI Bank Ltd' },
              { label: 'IDBI Bank Limited', value: 'IDBI Bank Limited' },
              { label: 'IDFC FIRST Bank Limited', value: 'IDFC FIRST Bank Limited' },
              { label: 'India Post Payments Bank Ltd', value: 'India Post Payments Bank Ltd' },
              { label: 'Indian Bank', value: 'Indian Bank' },
              { label: 'Indian Overseas Bank', value: 'Indian Overseas Bank' },
              { label: 'IndusInd Bank Ltd', value: 'IndusInd Bank Ltd' },
              { label: 'Industrial and Commercial Bank of China', value: 'Industrial and Commercial Bank of China' },
              { label: 'Industrial Bank of Korea', value: 'Industrial Bank of Korea' },
              { label: 'J&K Grameen Bank', value: 'J&K Grameen Bank' },
              { label: 'Jammu & Kashmir Bank Ltd', value: 'Jammu & Kashmir Bank Ltd' },
              { label: 'Jana Small Finance Bank Ltd', value: 'Jana Small Finance Bank Ltd' },
              { label: 'Jharkhand Rajya Gramin Bank', value: 'Jharkhand Rajya Gramin Bank' },
              { label: 'Jio Payments Bank Ltd', value: 'Jio Payments Bank Ltd' },
              { label: 'JP Morgan Chase Bank NA', value: 'JP Morgan Chase Bank NA' },
              { label: 'JSC VTB Bank', value: 'JSC VTB Bank' },
              { label: 'Karnataka Bank Ltd', value: 'Karnataka Bank Ltd' },
              { label: 'Karnataka Gramin Bank', value: 'Karnataka Gramin Bank' },
              { label: 'Karnataka Vikas Gramin Bank', value: 'Karnataka Vikas Gramin Bank' },
              { label: 'Karur Vysya Bank Ltd', value: 'Karur Vysya Bank Ltd' },
              { label: 'KEB Hana Bank', value: 'KEB Hana Bank' },
              { label: 'Kerala Gramin Bank', value: 'Kerala Gramin Bank' },
              { label: 'Kookmin Bank', value: 'Kookmin Bank' },
              { label: 'Kotak Mahindra Bank Ltd', value: 'Kotak Mahindra Bank Ltd' },
              { label: 'Madhya Pradesh Gramin Bank', value: 'Madhya Pradesh Gramin Bank' },
              { label: 'Madhyanchal Gramin Bank', value: 'Madhyanchal Gramin Bank' },
              { label: 'Maharashtra Gramin Bank', value: 'Maharashtra Gramin Bank' },
              { label: 'Manipur Rural Bank', value: 'Manipur Rural Bank' },
              { label: 'Mashreq bank PSC', value: 'Mashreq bank PSC' },
              { label: 'Meghalaya Rural Bank', value: 'Meghalaya Rural Bank' },
              { label: 'Mizoram Rural Bank', value: 'Mizoram Rural Bank' },
              { label: 'Mizuho Bank Ltd', value: 'Mizuho Bank Ltd' },
              { label: 'MUFG Bank, Ltd', value: 'MUFG Bank, Ltd' },
              { label: 'Nagaland Rural Bank', value: 'Nagaland Rural Bank' },
              { label: 'Nainital bank Ltd', value: 'Nainital bank Ltd' },
              { label: 'NatWest Markets Plc', value: 'NatWest Markets Plc' },
              { label: 'Nong Hyup Bank', value: 'Nong Hyup Bank' },
              { label: 'NSDL Payments Bank Limited', value: 'NSDL Payments Bank Limited' },
              { label: 'Odisha Gramya Bank', value: 'Odisha Gramya Bank' },
              { label: 'Paschim Banga Gramin Bank', value: 'Paschim Banga Gramin Bank' },
              { label: 'Paytm Payments Bank Ltd', value: 'Paytm Payments Bank Ltd' },
              { label: 'Prathama UP Gramin Bank', value: 'Prathama UP Gramin Bank' },
              { label: 'PT Bank Maybank Indonesia TBK', value: 'PT Bank Maybank Indonesia TBK' },
              { label: 'Puduvai Bharathiar Grama Bank', value: 'Puduvai Bharathiar Grama Bank' },
              { label: 'Punjab & Sind Bank', value: 'Punjab & Sind Bank' },
              { label: 'Punjab Gramin Bank', value: 'Punjab Gramin Bank' },
              { label: 'Punjab National Bank', value: 'Punjab National Bank' },
              { label: 'Qatar National Bank (QPSC)', value: 'Qatar National Bank (QPSC)' },
              { label: 'Rajasthan Marudhara Gramin Bank', value: 'Rajasthan Marudhara Gramin Bank' },
              { label: 'RBL Bank Ltd', value: 'RBL Bank Ltd' },
              { label: 'Saptagiri Grameena Bank', value: 'Saptagiri Grameena Bank' },
              { label: 'Sarva Haryana Gramin Bank', value: 'Sarva Haryana Gramin Bank' },
              { label: 'Saurashtra Gramin Bank', value: 'Saurashtra Gramin Bank' },
              { label: 'Sberbank', value: 'Sberbank' },
              { label: 'SBM Bank (India) Limited', value: 'SBM Bank (India) Limited' },
              { label: 'Shinhan Bank', value: 'Shinhan Bank' },
              { label: 'Shivalik Small Finance Bank Ltd', value: 'Shivalik Small Finance Bank Ltd' },
              { label: 'slice Small Finance Bank Ltd', value: 'slice Small Finance Bank Ltd' },
              { label: 'Societe Generale', value: 'Societe Generale' },
              { label: 'Sonali Bank Ltd', value: 'Sonali Bank Ltd' },
              { label: 'South Indian Bank Ltd', value: 'South Indian Bank Ltd' },
              { label: 'Standard Chartered Bank', value: 'Standard Chartered Bank' },
              { label: 'State Bank of India', value: 'State Bank of India' },
              { label: 'Sumitomo Mitsui Banking Corporation', value: 'Sumitomo Mitsui Banking Corporation' },
              { label: 'Suryoday Small Finance Bank Ltd', value: 'Suryoday Small Finance Bank Ltd' },
              { label: 'Tamil Nadu Grama Bank', value: 'Tamil Nadu Grama Bank' },
              { label: 'Tamilnad Mercantile Bank Ltd', value: 'Tamilnad Mercantile Bank Ltd' },
              { label: 'Telangana Grameena Bank', value: 'Telangana Grameena Bank' },
              { label: 'Tripura Gramin Bank', value: 'Tripura Gramin Bank' },
              { label: 'UBS AG', value: 'UBS AG' },
              { label: 'UCO Bank', value: 'UCO Bank' },
              { label: 'Ujjivan Small Finance Bank Ltd', value: 'Ujjivan Small Finance Bank Ltd' },
              { label: 'Union Bank of India', value: 'Union Bank of India' },
              { label: 'United Overseas Bank Limited', value: 'United Overseas Bank Limited' },
              { label: 'Unity Small Finance Bank Ltd', value: 'Unity Small Finance Bank Ltd' },
              { label: 'Utkal Grameen Bank', value: 'Utkal Grameen Bank' },
              { label: 'Utkarsh Small Finance Bank Ltd', value: 'Utkarsh Small Finance Bank Ltd' },
              { label: 'Uttar Bihar Gramin Bank', value: 'Uttar Bihar Gramin Bank' },
              { label: 'Uttarakhand Gramin Bank', value: 'Uttarakhand Gramin Bank' },
              { label: 'Uttarbanga Kshetriya Gramin Bank', value: 'Uttarbanga Kshetriya Gramin Bank' },
              { label: 'Vidharbha Konkan Gramin Bank', value: 'Vidharbha Konkan Gramin Bank' },
              { label: 'Woori Bank', value: 'Woori Bank' },
              { label: 'YES Bank Ltd', value: 'YES Bank Ltd' }
            ],


            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'Account_Number__c',
            required: true,
            name: 'Account_Number__c',
            label: 'Account Number',
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: /^[0-9]{9,18}$/,
                message: 'Please input a valid Account Number',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'IFSC_Number__c',

            name: 'IFSC_Number__c',
            label: 'IFSC Code',
            type: 'input',
            validations: {

              pattern: {
                value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                message: 'Please input a valid IFSC Code',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },


          // {
          // 	fieldId: "passportId",
          // 	//required: true,
          // 	name: "passportId",
          // 	label: "Passport Id",
          // 	type: "input",
          // 	validations: [
          // 		{
          // 			type: "required",
          // 			dataType: "string",
          // 			message: "Please enter your name",
          // 		},
          // 	],
          // 	ui: {
          // 		grid: {
          // 			xs: 12,
          // 			md: 6,
          // 			lg: 6,
          // 		},
          // 	},
          // },



        ],

      },
      {
        sectionName: 'OJT Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: "Outlet_Name__c",
            required: true,
            name: "Outlet_Name__c",
            label: "Outlet Name",
            type: "input",

            validations: {
              required: "This field is required",
              maxLength: {
                value: 200,
                message: "Full Name cannot exceed 200 characters"
              },
              pattern: {
                value: /^[a-zA-Z0-9\s]+$/,
                message: "Please enter a valid name (letters and numbers only)"
              }
            }
          },
          {
            fieldId: `OJT_Start_Date__c`,
            required: true,
            name: `OJT_Start_Date__c`,
            label: 'OJT Start Date',
            type: 'simpleDate',
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: `Outlet_address__c`,
            required: true,
            name: `Outlet_address__c`,
            label: 'Outlet Address',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: "TL_Name__c",
            required: true,
            name: "TL_Name__c",
            label: "TL Name",
            type: "input",

            validations: {
              required: "This field is required",
              maxLength: {
                value: 200,
                message: "TL Name cannot exceed 200 characters"
              },
              pattern: {
                value: REGEX.NAME,
                message: "TL Name should contain only alphabets and should not start or end with space"
              }
            }
          },
          {
            fieldId: `TL_Contact_No__c`,
            required: true,
            name: `TL_Contact_No__c`,
            label: 'TL Phone Number',
            type: 'phone',
            apiKey: `TL_Contact_No__c`,

            validations: {
              required: 'This field is required',
              pattern: {
                value: /^\+?91?[0-9]{10}$/,
                message: "Please enter a valid 10-digit Mobile Number"
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },

        ],
      },
      {
        sectionName: 'Student Documents',
        sectionId: 'studentDocuments',
        subSectionName: '',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'Resume',
            required: true,
            name: 'Resume',
            label: 'Resume',
            description: 'pdf, doc formats supported • Max file size 5 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], // pdf, doc, docx
              maxSize: 5 * 1024 * 1024, // 5 MB in bytes
              message: 'Only PDF or Word files up to 5MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'passportSizePhotograph',
            required: true,
            name: 'passportSizePhotograph',
            label: 'Passport Size Photograph',
            description: 'jpeg, jpg, png formats supported • Max file size 2 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['image/jpeg', 'image/jpg', 'image/png'],
              maxSize: 2 * 1024 * 1024,
              message: 'Only JPG, JPEG, or PNG images up to 2MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'qualificationUpload',
            required: true,
            name: 'qualificationUpload',
            label: 'Qualification Upload',
            description: 'pdf, doc formats supported • Max file size 5 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], // pdf, doc, docx
              maxSize: 5 * 1024 * 1024, // 5 MB in bytes
              message: 'Only PDF or Word files up to 5MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'adharCardUpload',
            required: true,
            name: 'adharCardUpload',
            label: 'Adhar Card Upload',
            description: 'pdf, doc formats supported • Max file size 5 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], // pdf, doc, docx
              maxSize: 5 * 1024 * 1024, // 5 MB in bytes
              message: 'Only PDF or Word files up to 5MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'panCardUpload',
            required: true,
            name: 'panCardUpload',
            label: 'Pan Card Upload',
            description: 'pdf, doc formats supported • Max file size 5 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], // pdf, doc, docx
              maxSize: 5 * 1024 * 1024, // 5 MB in bytes
              message: 'Only PDF or Word files up to 5MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'passbookCopy',
            required: true,
            name: 'passbookCopy',
            label: 'Bank PassBook / Cancelled Cheque Upload',
            description: 'pdf, doc formats supported • Max file size 5 MB',
            type: 'upload',
            validations: {
              allowedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], // pdf, doc, docx
              maxSize: 5 * 1024 * 1024, // 5 MB in bytes
              message: 'Only PDF or Word files up to 5MB are allowed'
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          }
        ]

      },

    ],
  },
];

function KenApplicationForm() {
  const [applicationData, setApplicationData] = useState();
  const query = new URLSearchParams(useLocation().search);
  const { formState, formDispatch } = useContext(FormContext);
  const [loader, setLoader] = useState(true);
  const [formLoader, setFormLoader] = useState(true);
  const [formJson, setFormJson] = useState([...formJSON]);
  const [currentActiveStep, setCurrentActiveStep] = useState();
  const [applicationFormData, setApplicationFormData] = useState();
  const [csc, setCsc] = useState([]);
  const [cscCopy, setCscCopy] = useState();
  const navigate = useNavigate();
  const { hasBack } = useBack();

  useEffect(() => {
    setFormLoader(true);

    const formId = "a0lIm0000008vtlIAA";

    getFormByFormId(formId)
      .then((res) => {
        console.log("form res", res);
        setApplicationFormData(res);

        // Get states of India
        const states = State.getStatesOfCountry("IN").map((s) => ({
          label: s.name,
          value: s.isoCode,
        }));

        // Update form JSON
        let updatedForm = [...formJSON];

        updatedForm = updatedForm.map((field) => {
          // Set default Country = India
          if (field.fieldId === "hed__MailingCountry__c") {
            return {
              ...field,
              value: "India", // default value
              options: [{ label: "India", value: "India" }],
            };
          }

          // Populate State dropdown options
          if (field.fieldId === "hed__MailingState__c") {
            return {
              ...field,
              options: states,
            };
          }

          return field;
        });

        setFormJson(updatedForm);

        // Set program details
        formDispatch({
          type: "update",
          payload: {
            programDetails: res?.data,
            application: {
              academicCycle: res?.data?.academicCycle,
              programId: res?.data?.programId,
              programName: res?.data?.programName,
            },
          },
        });

        setFormLoader(false);
        setLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
        setFormLoader(false);
        setLoader(false);
      });
  }, []);

  console.log(formJson, "fiormJson");


  return (
    <UploadDocumentContextProvider>
      {(loader || formLoader) && <KenLoader />}
      {!loader && !formLoader && (
        <KenFormBuilder
          formJSON={formJson}
          currentActiveStep={currentActiveStep}
          setCsc={setCsc}

        />
      )}
    </UploadDocumentContextProvider>
  );
}

export default KenApplicationForm;
